import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventBusService, LoggerFactory } from '@valhalla/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { UpdateTickersEventBusMessage } from './update-tickers-eventbus-message';

@Injectable()
export class UpdateTickersByRequestsInterceptor implements HttpInterceptor {
	constructor(readonly logFactory: LoggerFactory, readonly bus: EventBusService) {}

	readonly logger = this.logFactory.createLogger('UpdateTickersByRequestsInterceptor');
	readonly matchedUrls = [
		'MarkCommentsAsRead',
		'MarkCommentAsAnswered',
		'MarkCommentAsUnread',
		'MarkCommentAsNotMyQuetion',
		'MarkCommentAsQuestion',
		'comments/delete',
		'TCWeb.asmx/SetCommentColor',
	].map(u => u.toLowerCase());
	readonly index = {};

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap(_ => {
				if (this.check(req.url)) {
					this.logger.info(`update tickers after url action ${req.url}`);
					this.bus.createAndSend(UpdateTickersEventBusMessage);
				}
			})
		);
	}

	check(url: string) {
		if (!url) {
			return false;
		}
		if (this.index[url]) {
			return true;
		}
		const lcUrl = url.toLowerCase();
		if (this.matchedUrls.some(mu => lcUrl.indexOf(mu) !== -1)) {
			this.index[url] = true;
			return true;
		}
		return false;
	}
}

export const UpdateTickersByRequestsInterceptorProvider = {
	provide: HTTP_INTERCEPTORS,
	multi: true,
	useClass: UpdateTickersByRequestsInterceptor,
};
